/**
 * jrs-v2-cart-add-logo.js — "Add your logo" on plain cart lines (2026-09-14,
 * ClickUp 86eyw9j3h).
 *
 * Markup: snippets/jrs-cart-add-logo.liquid renders a
 * [data-jrs-add-logo="<line key>"] control only on eligible plain lines.
 *
 * Responsibilities
 *   1. Impression telemetry — cart:addLogoCtaImpression once per line key per page
 *      view, after every deferred module (incl. JRS.Analytics) has subscribed.
 *   2. Click — cart:addLogoCtaClicked, then open the customiser popup in cart-edit
 *      mode at position_picker (JRS.CustomizerPopup.openFromCartLine, mode
 *      'add_logo'). Save runs the existing add-before-remove cart-edit flow.
 *
 * Deliberately NOT data-jrs-edit-customization: jrs-v2-cart-edit-trigger.js binds a
 * document capture listener to that attribute, stops propagation and routes to the
 * edit destination (review step of an existing customisation).
 *
 * Analytics: EventBus → jrs-v2-analytics.js mapping → dataLayer
 * (jrs_cart_add_logo_cta_impression / jrs_cart_add_logo_cta_clicked).
 */

window.JRS = window.JRS || {};

(function (JRS) {
  'use strict';

  var SELECTOR = '[data-jrs-add-logo]';
  var _seen = {};
  var _bound = false;
  var _unsubs = [];

  function _controls(root) {
    var scope = root || document;
    return scope.querySelectorAll ? scope.querySelectorAll(SELECTOR) : [];
  }

  function _payloadFor(el, eligibleLineCount) {
    return {
      lineItemKey: el.getAttribute('data-jrs-add-logo') || '',
      productId: el.getAttribute('data-jrs-add-logo-product-id') || '',
      productType: el.getAttribute('data-jrs-add-logo-product-type') || '',
      eligibleLineCount: eligibleLineCount
    };
  }

  function _emit(name, payload) {
    if (JRS.EventBus && typeof JRS.EventBus.emit === 'function') {
      JRS.EventBus.emit(name, payload);
    }
  }

  /** Fire one impression per rendered line key not yet seen this page view. */
  function scanImpressions() {
    var els = _controls();
    var count = els.length;
    for (var i = 0; i < els.length; i++) {
      var key = els[i].getAttribute('data-jrs-add-logo');
      if (!key || _seen[key]) continue;
      _seen[key] = true;
      _emit('cart:addLogoCtaImpression', _payloadFor(els[i], count));
    }
  }

  function _onClick(e) {
    if (e && e.defaultPrevented) return;
    var target = e && e.target;
    var el = (target && typeof target.closest === 'function') ? target.closest(SELECTOR) : null;
    if (!el) return;
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    if (el.getAttribute('aria-busy') === 'true') return;

    var payload = _payloadFor(el, _controls().length);
    if (!payload.lineItemKey) return;
    _emit('cart:addLogoCtaClicked', payload);

    if (!JRS.CustomizerPopup || typeof JRS.CustomizerPopup.openFromCartLine !== 'function') {
      _reportOpenFailure(payload.lineItemKey, 'customizer_popup_unavailable');
      return;
    }
    el.setAttribute('aria-busy', 'true');
    var opened = JRS.CustomizerPopup.openFromCartLine({
      lineItemKey: payload.lineItemKey,
      mode: 'add_logo'
    });
    if (!opened || typeof opened.then !== 'function') {
      el.removeAttribute('aria-busy');
      return;
    }
    opened.then(function (res) {
      el.removeAttribute('aria-busy');
      if (!res || !res.ok) _reportOpenFailure(payload.lineItemKey, (res && (res.reason || res.error)) || 'unknown');
    }, function (err) {
      el.removeAttribute('aria-busy');
      _reportOpenFailure(payload.lineItemKey, (err && err.message) || 'unknown');
    });
  }

  function _reportOpenFailure(lineKey, detail) {
    try {
      if (JRS.ErrorTelemetry && typeof JRS.ErrorTelemetry.report === 'function') {
        JRS.ErrorTelemetry.report('cart_edit', 'cart_add_logo_open_failed', {
          silent: true,
          detail: String(detail),
          line_key: String(lineKey || '')
        });
      }
    } catch (_e) {}
  }

  function init() {
    if (_bound || typeof document === 'undefined') return;
    _bound = true;
    document.addEventListener('click', _onClick);
    if (JRS.EventBus && typeof JRS.EventBus.on === 'function') {
      // Rows re-rendered after a cart change: new line keys get their impression.
      _unsubs.push(JRS.EventBus.on('cart:updated', function () { scanImpressions(); }));
    }
    // Deferred scripts run before DOMContentLoaded; wait for it so JRS.Analytics
    // (loaded later in the same tier) has subscribed before the first impression.
    if (document.readyState === 'complete') {
      scanImpressions();
    } else {
      document.addEventListener('DOMContentLoaded', scanImpressions);
    }
  }

  function destroy() {
    if (typeof document !== 'undefined') {
      document.removeEventListener('click', _onClick);
      document.removeEventListener('DOMContentLoaded', scanImpressions);
    }
    for (var i = 0; i < _unsubs.length; i++) {
      try { if (typeof _unsubs[i] === 'function') _unsubs[i](); } catch (_e) {}
    }
    _unsubs = [];
    _seen = {};
    _bound = false;
  }

  JRS.CartAddLogo = {
    init: init,
    destroy: destroy,
    scanImpressions: scanImpressions,
    SELECTOR: SELECTOR
  };

  init();
})(window.JRS);
